import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
import Swiper from 'swiper';
import "swiper/dist/css/swiper.min.css";
import './assets/css/style.css';
import './assets/css/iconfont/iconfont.css';
// Vue.prototype.$swiper = Swiper
import App from './App'
import Print from 'vue-print-nb'
Vue.use(Print)
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
// import router from './router'
// import Router from 'vue-router'
// import {unique,hasBtn,removeByIndex,getTime,warehouse_location,material_parts,IMG_URL,IMG_URL_SHOW,outbound_order,material_requisition,router_url,screenHeight} from '../store/store'

// import JsonExcel from 'vue-json-excel'
// Vue.component('downloadExcel', JsonExcel)

import GeminiScrollbar from 'vue-gemini-scrollbar'
Vue.use(GeminiScrollbar)
import VueResource from 'vue-resource'
Vue.use(VueResource)

import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
Vue.component(CollapseTransition.name, CollapseTransition)

import uploads from '@/components/uploads';
Vue.component('uploads', uploads)
import upload from '@/components/upload';
Vue.component('upload', upload)
import upload_import from '@/components/upload_import';
Vue.component('upload_import', upload_import)
import pagination from '@/components/pagination';
Vue.component('pagination',pagination);

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import {unique,hasBtn,removeByIndex,getTime,IMG_URL,IMG_URL_SHOW,router_url,screenHeight} from '@/utils/index'

var table_height=screenHeight();
import {warehouse_location,material_parts,outbound_order,material_requisition,material_parts_img} from '@/utils/lodop'
// warehouse_location
import {export_blob,post_open,post_oauth,get_oauth} from './api/index'
import {get,post} from '@/utils/axios_config'
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$export_blob = export_blob
Vue.prototype.$post_open = post_open
Vue.prototype.$post_oauth = post_oauth
Vue.prototype.$get_oauth = get_oauth
// Vue.prototype.$getBtnStatus = getBtnStatus
Vue.prototype.$warehouse_location = warehouse_location
Vue.prototype.$material_parts = material_parts
Vue.prototype.$outbound_order = outbound_order
Vue.prototype.material_requisition = material_requisition
Vue.prototype.$material_parts_img = material_parts_img
Vue.prototype.router_url = router_url
Vue.prototype.hasBtn = hasBtn
Vue.prototype.removeByIndex = removeByIndex
Vue.prototype.getTime = getTime
Vue.prototype.IMG_URL = IMG_URL
Vue.prototype.IMG_URL_SHOW = IMG_URL_SHOW
Vue.prototype.screenHeight = screenHeight
Vue.prototype.table_height = table_height
Vue.prototype.unique = unique
Vue.config.productionTip = false

// 创建自定义指令
// Vue.directive('click-tooltip', {
//   bind(el, binding, vnode) {
//   	// console.log(el)
//     const tooltip = vnode.context.$createElement;
//     const vm = vnode.context;
//     const content = binding.value; // 指令值作为提示内容
//     const tooltipRef = tooltip('el-tooltip', {
//       props: {
//         content,
//         placement: 'right', // 你可以根据需要调整位置
//         effect:'light',
//         manual: true, // 设置为手动控制显示隐藏
//       },
//     }, [el]);
//     el.tooltip = tooltipRef;
//     el.vm = vm;
//     el.visible = false;
//     el.showTooltip = () => {
//     	console.log(1)
//       el.visible = true;
//       vm.$refs.tooltipRef = el.tooltip; // 挂载到vm上以便控制显示隐藏
//       el.vm.$nextTick(() => {
//         el.tooltip.visible = true; // 显示提示框
//       });
//     };
//     el.hideTooltip = () => {
//       el.visible = false;
//       el.vm.$nextTick(() => {
//         el.tooltip.visible = false; // 隐藏提示框
//       });
//     };
//   },
//   inserted(el) {
//     el.addEventListener('click', el.showTooltip);
//   },
//   unbind(el) {
//     el.removeEventListener('click', el.showTooltip);
//   }
// });


// import { common } from "@/mixin";
const mixin = {
	data(){
		return {
			isScreenFull:false,
		}
	},
	updated() {
		this.$nextTick(()=>{
			if(this.$refs.dataTable){
				this.$refs.dataTable.doLayout();
			}
		})
	},
};
Vue.mixin(mixin);
// Vue.mixin(common);
import Lodop from '@/../static/js/lodop/LodopFuncs';
Vue.use(Lodop)

import router from './permission' // 权限

import {componentInit} from "@/utils/autoRegister.js";
componentInit();

import AMapLoader from '@amap/amap-jsapi-loader';
// AMapLoader.load({
// 	key: 'fb4d7a75896456d1f5c9572a9b7b0f71',
// 	version: '2.0', // 指定地图的版本号
// 	plugins: ['AMap.TileLayer','AMap.ToolBar','AMap.Scale','AMap.ControlBar'] // 如果有需要加载的插件，可以在这里添加
// });
window.AMapInstance = null;
window.isAMapLoaded = false;
async function initGlobalAMap() {
  try {
    const AMap = await AMapLoader.load({
      key: "fb4d7a75896456d1f5c9572a9b7b0f71",
      version: "2.0",
      plugins: ['AMap.TileLayer','AMap.ToolBar','AMap.Scale','AMap.ControlBar','AMap.Geocoder']
    });
    Vue.prototype.$AMap = AMap;
    window.AMapInstance = AMap;
    window.isAMapLoaded = true;
  } catch (error) {
    console.error("高德地图全局加载失败：", error);
  }
}
initGlobalAMap().then(() => {
  new Vue({
  	el: '#app',
  	router,
  	components: {
  		App
  	},
  	template: '<App/>'
  })
})


// WEBPACK FOOTER //
// ./src/main.js